import React, { useState, useEffect } from 'react';
import './AllForDocument.scss';

import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';

import { IComponentDocument, IComponentVideoH } from '../../component';
import DocumentPPT from './DocumentPPT';

import intl from 'react-intl-universal';

import { getPageSameType } from '../../utils/util';

const AllForDocument = (props: IComponentDocument) => {
  let { documentStore, imStore } = props.rootStore!;
  const { component_cid, document_id } = props;

  const [showEmpty, setShowEmpty] = useState(false);
  const [documentId, setDocumentId] = useState(0);

  useEffect(() => {
    let video_id = 0;
    const onDocumentChange = (data: any) => {
      console.log(`on document change`, data);
      if (data && data.video_id == video_id) {
        documentStore.oneByMedium(video_id, true).then((res: any) => {
          if (res === null) {
            setShowEmpty(true);
          } else {
            setDocumentId(res.id);
          }
        });
      }
    };

    if(document_id) {
      setDocumentId(Number(document_id));
      documentStore.one(Number(document_id));
    }
    else if (component_cid) {
      // documentStore.one(document_id).then((res: any) => {
      //   if (res === null) {
      //     setShowEmpty(true);
      //   }
      // });
      let videoComponents = getPageSameType(
        window.pageDetail.template,
        [],
        'videoh'
      );
      if (videoComponents && videoComponents.length) {
        for (var i = 0; i < videoComponents.length; i++) {
          if (videoComponents[i].cid == component_cid) {
            video_id = (videoComponents[i] as IComponentVideoH).video_id;
            break;
          }
        }

        if (video_id) {
          documentStore.oneByMedium(video_id).then((res: any) => {
            if (res === null) {
              setShowEmpty(true);
            } else {
              setDocumentId(res.id);
            }
          });
        }
      }

      imStore.addMessageListener('document_change', onDocumentChange);
    } else {
      setShowEmpty(true);
    }

    return () => {
      imStore.removeMessageListener('document_change', onDocumentChange);
    };
  }, [component_cid, document_id]);

  const renderDocument = () => {
    const doc = documentStore.getVideo(documentId);
    if (doc) {
      switch (doc.type) {
        case 'pdf':
          return (
            <DocumentPPT {...props} data={doc} component_cid={component_cid} showAuto={!!component_cid && !document_id} />
          );
        default:
          return (
            <DocumentPPT {...props} data={doc} component_cid={component_cid} showAuto={!!component_cid && !document_id} />
          );
      }
    }
  };

  return (
    <div className="all-for-document">
      {showEmpty ? (
        <div className="document-empty">
          <img src={require('../../assets/document_empty.png')} />
          <span>{intl.get('DocumentEmpty')}</span>
        </div>
      ) : (
        renderDocument()
      )}
    </div>
  );
};

export default inject('rootStore')(observer(AllForDocument));
